import React from "react";
import { FormattedMessage } from "react-intl";
import css from "./KultSubjectGroupBadge.module.css";
var badgeOf = function (origin, overrideOrphaned) {
    if (overrideOrphaned)
        return "orphaned";
    if (origin === "MANUAL")
        return "manual";
    if (origin === "UNESCO")
        return "unesco";
    if (origin === "DERIVED")
        return "derived";
    return "unresolved";
};
var BADGE_CLASS = {
    orphaned: css.originMissing,
    manual: css.originManual,
    unesco: css.originUnesco,
    derived: css.originDerived,
    unresolved: css.originMissing,
};
export var KultSubjectGroupBadge = function (_a) {
    var _b;
    var origin = _a.origin, overrideOrphaned = _a.overrideOrphaned, orphanedOverrideCode = _a.orphanedOverrideCode, unescoCode = _a.unescoCode;
    var badge = badgeOf(origin, overrideOrphaned);
    return (React.createElement("span", { className: "".concat(css.origin, " ").concat(BADGE_CLASS[badge]), "data-testid": "kult-subject-group-origin", "data-origin": badge },
        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.kultSubjectGroup.badge.".concat(badge), values: {
                code: (_b = (badge === "unesco" ? unescoCode : orphanedOverrideCode)) !== null && _b !== void 0 ? _b : "",
            } })));
};
